import React from 'react';

interface MomentSkeletonProps {
  count?: number;
}

const MomentSkeleton: React.FC<MomentSkeletonProps> = ({ count = 3 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="bg-white border-b border-black/5 animate-pulse">
          {/* Header */}
          <div className="flex items-center gap-3 px-3 py-2.5">
            <div className="w-9 h-9 rounded-full bg-gray-200" />
            <div className="flex-1 space-y-1.5">
              <div className="h-3.5 w-24 bg-gray-200 rounded" />
            </div>
          </div>

          {/* Media Area */}
          <div className="aspect-square bg-gray-100" />

          {/* Action Bar */}
          <div className="flex items-center justify-between px-3 py-2">
            <div className="flex items-center gap-4">
              <div className="w-7 h-7 bg-gray-200 rounded" />
              <div className="w-7 h-7 bg-gray-200 rounded" />
              <div className="w-7 h-7 bg-gray-200 rounded" />
            </div>
            <div className="flex items-center gap-3">
              <div className="w-7 h-7 bg-gray-200 rounded" />
              <div className="w-7 h-7 bg-gray-200 rounded" />
            </div>
          </div>

          {/* Caption */}
          <div className="px-3 pb-3 space-y-2">
            <div className="h-4 w-3/4 bg-gray-200 rounded" />
            <div className="h-4 w-1/2 bg-gray-200 rounded" />
            <div className="h-3 w-20 bg-gray-100 rounded mt-2" />
          </div>
        </div>
      ))}
    </>
  );
};

export default MomentSkeleton;
